<template>
  <v-layout wrap style="height: 100px">
    <v-navigation-drawer v-model="enableFilters" persistent fixed width="600">
      <v-toolbar color="white" class="elevation-0">
        <v-toolbar-title>Filtros </v-toolbar-title>
      </v-toolbar>
      <v-spacer></v-spacer>
      <v-form>
        <v-container>
          <v-layout>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuStartAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedStartAtFormatted"
                    label="Data Inicial"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startAt"
                  no-title
                  @input="menuStartAt = false"
                  class="“no-pointer-events”"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuEndAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedEndAtFormatted"
                    label="Data Final"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endAt"
                  no-title
                  @input="menuEndAt = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <div>
            <v-subheader>Outros Filtros</v-subheader>
          </div>
          <v-layout v-if="partnerLevel === 'establishment'">
            <!--blank if establishment-->
          </v-layout>
          <v-layout v-else>
            <partner />
          </v-layout>
          <v-layout>
            <status />
            <brand />
          </v-layout>
          <v-layout>
            <amount />
          </v-layout>

          <v-layout>
            <terminal-number />
            <nsu-acquirer />
            <operation />
          </v-layout>
          <v-layout>
            <order />
          </v-layout>

          <v-btn @click="getResources">Enviar</v-btn>
          <v-btn @click="reset">Limpar</v-btn>
          <v-btn @click="desableFilters">Fechar</v-btn>
        </v-container>
      </v-form>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  created() {
    this.$store.dispatch("account/getAccount");
  },
  components: {
    Status: () => import("./options/Status.vue"),
    Brand: () => import("./options/Brand.vue"),
    TerminalNumber: () => import("./options/TerminalNumber.vue"),
    NsuAcquirer: () => import("./options/NsuAcquirer.vue"),
    Operation: () => import("./options/Operation.vue"),
    Order: () => import("./options/Order.vue"),
    Partner: () => import("./options/Partner.vue"),
    Amount: () => import("./options/Amount.vue"),
  },
  data: (vm) => ({
    startAt: null,
    endAt: null, // setted to null, because vuex is not rendering the date
    startAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'start'),
    endAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'end'),
    menuStartAt: false,
    menuEndAt: false,
    enableFilters: false,
  }),
  computed: {
    status: {
      get() {
        return this.status;
      },
      set(newStatus) {
        this.$store.dispatch("payments/setStatus", newStatus);
        this.status;
      },
    },
    partner: {
      get() {
        return this.partner;
      },
      set(newPartner) {
        this.$store.dispatch("payments/setPartner", newPartner);
        this.partner;
      },
    },
    cardBrand: {
      get() {
        return this.credit_card_brand;
      },
      set(newCardBrand) {
        this.$store.dispatch("payments/setCardBrand", newCardBrand);
        this.credit_card_brand;
      },
    },
    terminalNumber: {
      get() {
        return this.terminalNumber;
      },
      set(newTerminalNumber) {
        this.$store.dispatch("payments/setTerminalNumber", newTerminalNumber);
        this.terminalNumber;
      },
    },
    nsuAcquirer: {
      get() {
        return this.nsuAcquirer;
      },
      set(newNsuAcquirer) {
        this.$store.dispatch("payments/setNsuAcquirer", newNsuAcquirer);
        this.nsuAcquirer;
      },
    },
    operation: {
      get() {
        return this.operation;
      },
      set(value) {
        this.$store.dispatch("payments/setOperation", value);
        this.operation;
      },
    },
    ordination: {
      get() {
        return this.ordination;
      },
      set(value) {
        this.$store.dispatch("payments/setOrdination", value);
        this.ordination;
      },
    },
    ...mapGetters({
      filters: "payments/filter",
      page: "payments/page",
      limit: "payments/limit",
      status: "payments/filtersStatus",
      credit_card_brand: "payments/filtersCardBrand",
      terminalNumber: "payments/filtersTerminalNumber",
      nsuAcquirer: "payments/filtersNsuAcquirer",
      operation: "payments/filtersOperation",
      ordination: "payments/filtersOrdination",
      showFilters: "payments/showFilters",
      isLoading: "payments/loadingData",
      filtersPartner: "payments/filtersPartner",
      filtersMinAmount: "payments/filtersMinAmount",
      filtersMaxAmount: "payments/filtersMaxAmount",
      partnerLevel: "account/partner",
    }),
    computedStartAtFormatted() {
      return this.formatDate(this.startAt, 'start');
    },
    computedEndAtFormatted() {
      return this.formatDate(this.endAt, 'end');
    },
  },
  watch: {
    showFilters(newValue) {
      this.enableFilters = newValue;
    },
    startAt(val) {
      this.startAtFormatted = this.formatDate(this.startAt, 'start');
      this.$store.commit('payments/SET_FILTER_INITIAL_DATE', this.startAtFormatted);
    },
    endAt(val) {
      this.endAtFormatted = this.formatDate(this.endAt, 'end');
      this.$store.commit('payments/SET_FILTER_FINAL_DATE', this.endAtFormatted);
    },
  },
  methods: {
    getResources() {
      // Force limit to 10 to avoid the limit=1 issue
      const limitToUse = 10;
      
      this.params = {
        page: this.page,
        limit: limitToUse,
        filterrific: {
          with_created_at_between: {
            start_at: this.formatDate(this.startAt, 'start'),
            end_at: this.formatDate(this.endAt, 'end'),
          },
          status: this.status,
          credit_card_brand: this.credit_card_brand,
          with_terminal_number: this.terminalNumber,
          operation: this.operation,
          with_partner: this.filtersPartner,
          sorted_by: this.ordination,
          with_amount_gteq: this.filtersMinAmount,
          with_amount_lteq: this.filtersMaxAmount,
        },
        nsu_acquirer_cont: this.nsuAcquirer
      };
      
      
      this.$store.commit("payments/FILTER_PARAMS", this.params);
      this.$store.dispatch("payments/load", this.params);
      this.desableFilters();
    },
    desableFilters() {
      this.$store.dispatch("payments/showFilters", false);
      this.enableFilters = false;
    },

    reset() {
      this.$store.dispatch("payments/resetFilters", this.filters);
      this.$store.dispatch("payments/showFilters", false);
      this.$store.dispatch("payments/load");
    },
    formatDate(date, kind) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (kind == 'start') { 
        return `${day}/${month}/${year} 00:00:00`;
      } else {
        return `${day}/${month}/${year} 23:59:00`;
      }  
    }
  },
};
</script>
